module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.getStatus[_vm.arrematante.status]) ? _c('span', {
    class: 'text-' + _vm.getStatus[_vm.arrematante.status].class
  }, [(_vm.arrematante.status === 0) ? _c('i', {
    staticClass: "fa fa-bell"
  }) : _vm._e(), _vm._v(" "), (_vm.arrematante.status === 1) ? _c('i', {
    staticClass: "fa fa-check"
  }) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.getStatus[_vm.arrematante.status].titulo) + "\n          ")]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-053a4eb2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/arematantes/components/AnaliseAStatus.vue
// module id = 698
// module chunks = 2